/**
 * Display helpers. Storage stays E.164 (§0.5) — these only affect what a person
 * reads on screen, never what is sent to the server.
 */

/** +919876543210 → +91 98765 43210. Other country codes are left alone. */
export function formatPhone(e164: string): string {
  const m = e164.match(/^\+91(\d{5})(\d{5})$/);
  if (m) return `+91 ${m[1]} ${m[2]}`;
  return e164;
}

/**
 * wa.me share link (§2 — v1 sends from the staff device, no Business API).
 * The number must be digits only, no '+'.
 */
export function waMeLink(e164: string, message: string): string {
  return `https://wa.me/${e164.replace(/^\+/, '')}?text=${encodeURIComponent(message)}`;
}

/**
 * The timezones offered in the picker. `Intl.supportedValuesOf` gives the full
 * IANA list in current browsers; the fallback covers where NRI customers
 * actually are, so the picker is never empty.
 */
export function timezoneOptions(): string[] {
  try {
    const anyIntl = Intl as unknown as { supportedValuesOf?: (k: string) => string[] };
    if (typeof anyIntl.supportedValuesOf === 'function') {
      return anyIntl.supportedValuesOf('timeZone');
    }
  } catch {
    // fall through
  }
  return [
    'Asia/Kolkata',
    'America/Toronto',
    'America/New_York',
    'America/Los_Angeles',
    'America/Vancouver',
    'Europe/London',
    'Australia/Sydney',
    'Australia/Melbourne',
    'Asia/Dubai',
    'Asia/Singapore',
    'Pacific/Auckland',
  ];
}

/** The guest's local time right now, for the sapphire timezone tag (§5). */
export function timeInZone(tz: string): string | null {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      weekday: 'short',
    }).format(new Date());
  } catch {
    return null;
  }
}
